import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

// components
import ErrorBoundary from 'layout/components/ErrorBoundary';
import PageShell from 'layout/components/PageShell';
import Faq from 'appExplainers/components/Faq';

// styles
import * as PageLayout from 'layout/styles/PageLayout.style';

export default function FaqPage(): JSX.Element {
  const { t } = useTranslation('pageAbout');
  const history = useHistory();
  const [hasInAppHistory] = useState(history.action !== 'POP');

  return (
    <ErrorBoundary>
      <PageLayout.Page>
        <PageShell
          title={t('pageFaq.header')}
          onBackClick={hasInAppHistory ? () => history.goBack() : undefined}
          showBackButton={hasInAppHistory}
          showOnDesktop
          backButtonAriaLabel={t('pageFaq.back')}
        >
          <Faq />
        </PageShell>
      </PageLayout.Page>
    </ErrorBoundary>
  );
}
